<template>
  <section class="error-page">
    <h1
      v-if="error?.statusCode === 404"
      class="grey-text"
    >
      Page Not Found
    </h1>
    <h1
      v-else
      class="grey-text"
    >
      An error occurred
    </h1>
    <p class="light-grey-text">{{ error?.message }}</p>
    <DynamicButton
      text="Go to home"
      color="pink"
      @click-event="handleError"
    />
  </section>
</template>

<script setup lang="ts">
interface NuxtErrorData {
  statusCode?: number;
  message?: string;
}

defineProps<{
  error: NuxtErrorData;
}>();

function handleError() {
  clearError({ redirect: "/" });
}
</script>

<style scoped>
.error-page {
  padding: 15rem 10%;
  text-align: center;
  width: 80%;
}
</style>
